import { request } from "./apiClient";

export const locationService = {
  // Public pages should only show active locations by default.
  getLocations: ({ active = true } = {}) =>
    request(`/locations?active=${active ? "true" : "false"}`),
  getLocationById: (id, { incView = false } = {}) =>
    request(`/locations/${encodeURIComponent(id)}?incView=${incView ? "1" : "0"}`),
  getLocationBySlug: (slug, { incView = false } = {}) =>
    request(`/locations/slug/${encodeURIComponent(slug)}?incView=${incView ? "1" : "0"}`),
  bumpViewBySlug: (slug) =>
    request(`/locations/slug/${encodeURIComponent(slug)}/view`, { method: "POST" }),
};

